import FlixRoadmaprLogo from '../../../assets/imgs/flixroadmapr-logo.svg';
import { APP_PAGES } from '../../Constants';

export const HEADER_BRAND = ({ timeframe, team, redirectToRoot }) => ({
  alt: 'FlixRoadmapr Logo',
  image: FlixRoadmaprLogo,
  href: `${(redirectToRoot && APP_PAGES.root.path()) || APP_PAGES.home.path(timeframe, team)}`,
});
